import { PromotionContextProvider } from "src/contexts/promotion.context";
import { PromoWrapper } from "./ProductList.styled";
import { PromotionBlockSkeleton } from "./PromotionBlockSkeleton";
import { BrandsPromo } from "src/molecules/BrandsPromo";
import { useNewIsLoggedIn } from "src/hooks/useIsLoggedIn";

function Promotion({
  gender,
  slug,
}: {
  gender: string;
  slug: string;
}): JSX.Element {
  const { isLoggedIn, isSessionLoading } = useNewIsLoggedIn();

  return (
    <PromoWrapper>
      {isSessionLoading ? <PromotionBlockSkeleton /> : null}

      {!isSessionLoading && isLoggedIn ? (
        <PromotionContextProvider>
          <BrandsPromo slug={slug} />
        </PromotionContextProvider>
      ) : null}
    </PromoWrapper>
  );
}

export { Promotion };
